import { styled } from 'styled-components';

const typographyVariant = {
  header1: 'NotoSansKR-Medium',
  header2: 'NotoSansKR-Medium',
  header3: 'NotoSansKR-Regular',
  header4: 'NotoSansKR-Regular',
  content1: 'NotoSansKR-Regular',
  content2: 'NotoSansKR-Light',
  content3: 'NotoSansKR-Light',
  caption: 'NotoSansKR-Thin',
};

const typographySize = {
  header1: '1.9rem',
  header2: '1.4rem',
  header3: '1.2rem',
  header4: '1.05rem',
  content1: '0.9rem',
  content2: '0.8rem',
  content3: '0.7rem',
  caption: '0.6rem',
};

const Typography = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== 'variant',
})`
  white-space: pre-wrap;
  font-family: ${(props) =>
    props.variant ? typographyVariant[props.variant] : 'NotoSansKR-Light'};
  font-size: ${(props) =>
    props.variant ? typographySize[props.variant] : '1rem'};
`;

export default Typography;
